import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDXaEArCVggn9PKRNPahWZeRlALfUAvxzs",
  authDomain: "stuttgart-stage2.firebaseapp.com",
  databaseURL: "https://stuttgart-stage2.firebaseio.com",
  projectId: "stuttgart-stage2",
  storageBucket: "stuttgart-stage2.firebasestorage.app",
  messagingSenderId: "416151937489",
  appId: "1:416151937489:web:447c26468e69f276b1c0f0"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

const useEmulators = process.env.REACT_APP_USE_EMULATORS === "1";

if (useEmulators) {
  console.log("🔥 Using Firebase EMULATORS");
  connectAuthEmulator(auth, "http://127.0.0.1:9095");
} else {
  console.log("✅ Using LIVE Firebase");
}
